export const EMAIL_SENDER_BASE_QUERY_KEY = 'email-sender-settings';

export const emailSenderApiQueryKeys = {
  all: () => [EMAIL_SENDER_BASE_QUERY_KEY] as const,
};
